<label class="common-switch__label-container"
  [for]="'switch-' + fieldTypeSwitch.id"
  [attr.disabled]="disabled?true:null">
  <input [id]="'switch-' + fieldTypeSwitch.id"
    type="checkbox"
    class="common-radio-button__no-input"
    [disabled]="disabled"
    [(ngModel)]="fieldTypeSwitch.checked"
    (change)="toggleSwitch()">
  <div [ngClass]="{'common-switch__container': !field.negativeColor && !small,
    'common-switch__container-small': !field.negativeColor && small,
    'common-switch__bg-container': field.negativeColor && !small,
    'common-switch__bg-container-small': field.negativeColor && small,
    'common-switch__container--active': fieldTypeSwitch.selected && !field.negativeColor && !small,
    'common-switch__bg-container--active': fieldTypeSwitch.selected && field.negativeColor && !small,
    'common-switch__container-small--active': fieldTypeSwitch.selected && !field.negativeColor && small,
    'common-switch__bg-container-small--active': fieldTypeSwitch.selected && field.negativeColor && small,}"
    [attr.disabled]="disabled?true:null">
    <div class="common-switch__icon-circle-little"></div>
  </div>
  @if(field.label){
    <p [ngClass]="{'common-switch__label-text-negative': field.negativeColor && !small,
      'common-switch__label-text': !field.negativeColor && !small,
      'common-switch__label-text-small': !field.negativeColor && small,
      'common-switch__label-text-negative-small': field.negativeColor && small}">
      <span>{{field.label}}</span>
      @if (field.description) {
        <tooltip-info [description]="field.description"></tooltip-info>
      }
    </p>
  }
</label>